export default __webpack_public_path__ + "static/media/fw-evelyn-er-White Gold.e285725f.mp4";